export default "__VITE_ASSET__cY9GZL_$__"